import { tv } from 'tailwind-variants'

export const checkInItemVariants = tv({
  base: [
    'relative',
    'flex-shrink-0',
    'w-[140px]',
    'px-2 pb-3 pt-0',
    'rounded-10',
    'hover:z-[9997]'
  ],
  variants: {
    status: {
      unused: ['z-10', 'shadow-yellow-top-accent-inset bg-glass-overlay-strong'],
      auto: ['z-10', 'shadow-yellow-top-accent-inset bg-glass-overlay-strong'],
      used: ['z-10', 'shadow-green-top-accent-inset bg-glass-overlay-strong'],
      expired: ['shadow-white-top-accent-inset bg-glass-overlay-light'],
      locked: ['shadow-white-top-accent-inset bg-glass-overlay-light']
    }
  }
})

export const checkInItemTextVariants = tv({
  slots: {
    boost: ['text-center text-2xl font-bold font-formula'],
    label: ['text-sm font-bold font-formula uppercase text-center']
  },
  variants: {
    status: {
      unused: {
        boost: 'text-dark-yellow',
        label: 'text-white'
      },
      used: {
        boost: 'text-dark-green',
        label: 'text-white'
      },
      auto: {
        boost: 'text-dark-yellow',
        label: 'text-white'
      },
      expired: {
        boost: 'text-white/60',
        label: 'text-white/40'
      },
      locked: {
        boost: 'text-white/60',
        label: 'text-white/40'
      }
    }
  }
})

export const CheckInItemRingVariants = tv({
  base: 'absolute inset-0 -top-8',
  variants: {
    status: {
      unused: 'opacity-100',
      used: 'opacity-100',
      auto: 'opacity-100',
      expired: 'opacity-50',
      locked: 'opacity-50'
    }
  }
})
